/* Free Magic Water bar — Anvati Beauty
 * Shows progress to the free gift in the cart drawer and on the cart page,
 * and lets the customer add the free Magic Water Cream (Argan or Keratin).
 * The discount itself is the Shopify automatic discount "FREE Magic Water on AED 299+".
 */
(function () {
  'use strict';
  var C = window.FreeGiftBar;
  if (!C) return;

  var AR = C.locale === 'ar';
  var ROOT = C.root.slice(-1) === '/' ? C.root : C.root + '/';
  var GIFT_IDS = C.gifts.map(function (g) { return Number(g.id); });
  var cart = null;
  var timer = null;
  var busy = false;

  var T = AR
    ? {
        away: function (m) { return 'باقي لك <b>' + m + '</b> وتاخذين <b>كريم ماجيك ووتر مجاناً</b> 🎁'; },
        unlocked: '🎉 مبروك! <b>كريم ماجيك ووتر</b> صار مجاني لك، اختاري اللي تبينه:',
        add: function (n) { return 'أضيفي ' + n + ' مجاناً'; },
        inBag: '✅ <b>كريم ماجيك ووتر المجاني</b> صار في سلتك',
        notYet: function (m) { return 'باقي لك <b>' + m + '</b> عشان يصير <b>كريم ماجيك ووتر</b> مجاني'; },
        error: 'صار خطأ، حاولي مرة ثانية',
        pdpOffer: function (m) { return '🎁 <b>كريم ماجيك ووتر مجاناً</b> لأي طلب فوق ' + m; },
        pdpUnlocked: '🎉 طلبك مؤهل لـ<b>كريم ماجيك ووتر مجاناً</b>، اختاريه من السلة',
        pdpInBag: '✅ <b>كريم ماجيك ووتر المجاني</b> في سلتك',
      }
    : {
        away: function (m) { return 'You\'re <b>' + m + '</b> away from a <b>FREE Magic Water Cream</b> 🎁'; },
        unlocked: '🎉 You unlocked a <b>FREE Magic Water Cream</b>! Choose yours:',
        add: function (n) { return 'Add ' + n + ' — FREE'; },
        inBag: '✅ Your <b>FREE Magic Water Cream</b> is in your bag',
        notYet: function (m) { return 'Add <b>' + m + '</b> more to get your <b>Magic Water Cream FREE</b>'; },
        error: 'Something went wrong, please try again',
        pdpOffer: function (m) { return '🎁 <b>FREE Magic Water Cream</b> on orders over ' + m; },
        pdpUnlocked: '🎉 Your order gets a <b>FREE Magic Water Cream</b>. Pick it in your cart',
        pdpInBag: '✅ Your <b>FREE Magic Water Cream</b> is in your bag',
      };

  function rate() {
    var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  }

  function money(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? String(v) : v.toFixed(2);
    var cur = (cart && cart.currency) || 'AED';
    if (cur === 'AED') return AR ? s + ' درهم' : 'AED ' + s;
    return cur + ' ' + s;
  }

  function computeState() {
    var threshold = Math.round(C.threshold * rate());
    var qualifying = 0;
    var giftInCart = false;
    (cart.items || []).forEach(function (it) {
      if (GIFT_IDS.indexOf(Number(it.variant_id)) !== -1) giftInCart = true;
      else qualifying += it.final_line_price;
    });
    return {
      threshold: threshold,
      qualifying: qualifying,
      remaining: Math.max(0, threshold - qualifying),
      unlocked: qualifying >= threshold,
      giftInCart: giftInCart,
      percent: Math.min(100, Math.round((qualifying / threshold) * 100)),
    };
  }

  function bar(percent) {
    return '<div class="fgb__track"><div class="fgb__fill" style="width:' + percent + '%"></div></div>';
  }

  function render() {
    var s = computeState();
    if (s.unlocked && s.giftInCart) return '<p class="fgb__msg">' + T.inBag + '</p>';
    if (s.unlocked) {
      var btns = C.gifts
        .filter(function (g) { return g.available; })
        .map(function (g) {
          return (
            '<button type="button" class="fgb__btn" data-fgb-add="' + g.id + '">' +
            (g.img ? '<img src="' + g.img + '" alt="" width="36" height="36" loading="lazy">' : '') +
            '<span>' + T.add(AR ? g.ar : g.en) + '</span></button>'
          );
        })
        .join('');
      return '<p class="fgb__msg">' + T.unlocked + '</p>' + (btns ? '<div class="fgb__btns">' + btns + '</div>' : '');
    }
    var msg = s.giftInCart ? T.notYet(money(s.remaining)) : T.away(money(s.remaining));
    return '<p class="fgb__msg">' + msg + '</p>' + bar(s.percent);
  }

  function targets() {
    var list = [];
    var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (drawerInner) {
      var header = drawerInner.querySelector('.drawer__header');
      list.push({ parent: drawerInner, before: header ? header.nextSibling : drawerInner.firstChild });
    }
    var pageItems = document.getElementById('main-cart-items');
    if (pageItems && pageItems.parentNode) list.push({ parent: pageItems.parentNode, before: pageItems });
    return list;
  }

  // Short note under the product page's add-to-cart button
  function renderPdp() {
    var s = computeState();
    if (s.unlocked && s.giftInCart) return T.pdpInBag;
    if (s.unlocked) return T.pdpUnlocked;
    if (!cart.item_count) return T.pdpOffer(money(s.threshold));
    var msg = s.giftInCart ? T.notYet(money(s.remaining)) : T.away(money(s.remaining));
    return msg + bar(s.percent);
  }

  function paint() {
    if (!cart) return;
    document.querySelectorAll('.fgb-pdp').forEach(function (el) {
      var h = renderPdp();
      if (el.innerHTML !== h) el.innerHTML = h;
    });
    var empty = !cart.item_count;
    var html = empty ? '' : render();
    targets().forEach(function (t) {
      var el = t.parent.querySelector(':scope > .fgb');
      if (empty) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('div');
        el.className = 'fgb';
        el.setAttribute('dir', AR ? 'rtl' : 'ltr');
        t.parent.insertBefore(el, t.before);
      }
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  function load() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; paint(); })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(load, 200);
  }

  function addGift(id, button) {
    if (busy) return;
    busy = true;
    if (button) button.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer && !onCartPage) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json && res.json.description);
        if (onCartPage) { window.location.reload(); return; }
        if (drawer && res.json.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res.json);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift-bar' });
        }
        return load();
      })
      .catch(function () {
        if (button) {
          button.removeAttribute('aria-busy');
          var p = button.closest('.fgb');
          if (p && !p.querySelector('.fgb__err')) {
            var e = document.createElement('p');
            e.className = 'fgb__err';
            e.textContent = T.error;
            p.appendChild(e);
          }
        }
      })
      .then(function () { busy = false; });
  }

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-fgb-add]');
      if (!btn) return;
      e.preventDefault();
      addGift(btn.getAttribute('data-fgb-add'), btn);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }

    // Dawn replaces the drawer's HTML after every change — put the bar back when that happens
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && window.MutationObserver) {
      new MutationObserver(function () {
        var inner = document.querySelector('#CartDrawer .drawer__inner');
        if (inner && !inner.querySelector(':scope > .fgb')) schedule();
      }).observe(drawerEl, { childList: true, subtree: true });
    }

    load();
  }

  // Wait until the theme's own scripts (pubsub.js, constants.js) have run
  var started = false;
  function start() { if (started) return; started = true; init(); }
  document.addEventListener('DOMContentLoaded', start);
  window.addEventListener('load', start);
  if (document.readyState === 'complete') start();
})();
